module.exports = __webpack_public_path__ + "static/media/landing page.4c661ff8.jpg";